import {styled} from 'styled-components';

import {NavButton} from '@shared-web/components/core/button';

import {ProjectListPage} from '@src/components/project_list_page';
import {Search} from '@src/components/search';
import {useProjects} from '@src/lib/projects_stores';

export const HomePage: React.FC = () => {
  const projects = useProjects();

  return (
    <Wrapper>
      <Search />
      {projects.length === 0 ? (
        <FirstRunWrapper>
          <Title>Bienvenue !</Title>
          <NavButton to="/create-project">Démarrer une session de recherche</NavButton>
          <NavButton to="/browse">Explorer les prénoms</NavButton>
        </FirstRunWrapper>
      ) : (
        <NormalWrapper>
          <Title>
            Vous avez {projects.length} session{projects.length > 1 ? 's' : ''} de recherche en
            cours :
          </Title>
          <ProjectListPage />
          <NavButton to="/create-project">Démarrer une session de recherche</NavButton>
          <NavButton to="/browse">Explorer les prénoms</NavButton>
        </NormalWrapper>
      )}
    </Wrapper>
  );
};
HomePage.displayName = 'HomePage';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 1rem;
  padding-top: max(env(safe-area-inset-top), 1rem);
  padding-bottom: max(env(safe-area-inset-bottom), 1rem);
`;

const FirstRunWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  text-align: center;
  flex-grow: 1;
`;

const Title = styled.div`
  font-size: 1.5rem;
  color: #4e4e4e;
  text-align: center;
`;

const NormalWrapper = styled.div`
  margin-top: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: stretch;
  gap: 1rem;
`;
